import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import NotFoundContainerQuery, {
	type NotFoundContainerQuery$data,
	type NotFoundContainerQuery$variables,
} from './__generated__/NotFoundContainerQuery.graphql';

export const preloadDraftRedirect = ({
	contentId,
	draftShareId,
}: {
	contentId: string;
	draftShareId: string;
}) => {
	return query<NotFoundContainerQuery$data, NotFoundContainerQuery$variables>({
		query: NotFoundContainerQuery,
		variables: { contentId, draftShareId, status: ['draft'] },
	});
};
